













import Vue from "vue";

export default Vue.extend({
  name: "ProjectDetailsOverlay",
  props: {
    visible: Boolean,
    color: String,
    title: String,
    htmlContent: String,
  },
  data() {
    return {
      localVisible: this.visible,
    };
  },
  methods: {
    openDialog() {
      this.localVisible = true;
    },
    closeDialog() {
      this.localVisible = false;
    },
    handleClickOutside(event: MouseEvent) {
      const dialog = this.$refs.dialog as HTMLElement;

      if (dialog && !dialog.contains(event.target as Node)) {
        this.closeDialog();
        this.$emit('close');
      }
    },
    getImage: function(url: string) {
      console.log("fetching image " + url);
    }
  }
});
